/* Brands Only — account-gated wishlist.
   Login required: saving/viewing only works for a logged-in customer (window.boWishlist.customerId).
   Storage: localStorage keyed per customer (bo_wishlist_<id>). The read/write layer is isolated in
   Store() so it can be swapped for a server-side customer-metafield sync (App Proxy) later without
   touching the UI. Hearts are any [data-bo-wish] element with data-wish-* attributes. */
(function () {
  var cfg = window.boWishlist || {};
  var CID = cfg.customerId ? String(cfg.customerId) : null;
  var LOGIN = cfg.loginUrl || '/account/login';

  var Store = {
    key: function () { return 'bo_wishlist_' + (CID || 'guest'); },
    all: function () { if (!CID) return []; try { return JSON.parse(localStorage.getItem(this.key())) || []; } catch (e) { return []; } },
    save: function (list) { try { localStorage.setItem(this.key(), JSON.stringify(list)); } catch (e) {} },
    has: function (id) { return this.all().some(function (x) { return String(x.id) === String(id); }); },
    add: function (item) { var l = this.all(); if (!this.has(item.id)) { l.push(item); this.save(l); } },
    remove: function (id) { this.save(this.all().filter(function (x) { return String(x.id) !== String(id); })); },
    count: function () { return this.all().length; }
  };

  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function toast(msg, label, href) {
    var t = document.createElement('div');
    t.className = 'bo-wish-toast';
    t.innerHTML = '<span>' + esc(msg) + '</span>' + (href ? ' <a href="' + href + '">' + esc(label) + '</a>' : '');
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-show'); });
    setTimeout(function () { t.classList.remove('is-show'); setTimeout(function () { if (t.parentNode) t.remove(); }, 300); }, 4500);
  }

  function dataFrom(btn) {
    return {
      id: btn.getAttribute('data-wish-id'),
      url: btn.getAttribute('data-wish-url'),
      title: btn.getAttribute('data-wish-title'),
      image: btn.getAttribute('data-wish-image'),
      price: btn.getAttribute('data-wish-price'),
      compare: btn.getAttribute('data-wish-compare') || ''
    };
  }

  function updateCount() {
    var n = Store.count();
    document.querySelectorAll('[data-bo-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  function markButtons() {
    var list = Store.all();
    document.querySelectorAll('[data-bo-wish]').forEach(function (btn) {
      var on = list.some(function (x) { return String(x.id) === String(btn.getAttribute('data-wish-id')); });
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function toggle(btn) {
    if (!CID) { toast('Meld je aan om je favorieten te bewaren.', 'Inloggen', LOGIN); return; }
    var id = btn.getAttribute('data-wish-id');
    if (Store.has(id)) Store.remove(id); else Store.add(dataFrom(btn));
    markButtons();
    updateCount();
    renderPage();
  }

  function bind() {
    document.querySelectorAll('[data-bo-wish]').forEach(function (btn) {
      if (btn.dataset.boBound) return;
      btn.dataset.boBound = '1';
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(btn); });
      btn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(btn); } });
    });
    markButtons();
    updateCount();
  }

  function renderPage() {
    var host = document.getElementById('bo-wishlist-items');
    if (!host) return;
    var empty = document.getElementById('bo-wishlist-empty');
    var list = Store.all();
    if (!list.length) { host.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    host.innerHTML = list.map(function (p) {
      return '<div class="bo-wl-card">' +
        '<button type="button" class="bo-wl-card__remove" data-wish-remove="' + esc(p.id) + '" aria-label="Verwijderen uit favorieten">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<a href="' + esc(p.url) + '" class="bo-wl-card__media">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
        '<a href="' + esc(p.url) + '" class="bo-wl-card__title">' + esc(p.title) + '</a>' +
        '<div class="bo-wl-card__price"><span class="' + (p.compare ? 'is-sale' : '') + '">' + esc(p.price) + '</span>' + (p.compare ? ' <s>' + esc(p.compare) + '</s>' : '') + '</div>' +
        '<a href="' + esc(p.url) + '" class="bo-wl-card__btn">Bekijk product</a>' +
        '</div>';
    }).join('');
    host.querySelectorAll('[data-wish-remove]').forEach(function (b) {
      b.addEventListener('click', function () { Store.remove(b.getAttribute('data-wish-remove')); markButtons(); updateCount(); renderPage(); });
    });
  }

  function init() { bind(); renderPage(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
